import { PrimaryLanguageLocale } from "commonui";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
	components: {}
})
export default class FlagIcon extends Vue {
	@Prop() flagType?: PrimaryLanguageLocale;
	@Prop({ default: 20 }) height!: number;
	@Prop({ default: 20 }) width!: number;

	get flagLanguage() {
		return PrimaryLanguageLocale;
	}
}
